import React from 'react'
import classNames from 'classnames'
import SliderWithScrollLock, {
  Settings,
  CustomArrowProps
} from '#src/components/SliderWithScrollLock'
import ArrowLeft from './arrow-left.svg'
import ArrowRight from './arrow-right.svg'
import styles from './styles.css'

interface Props {
  settings?: Settings
}

const NextArrow: React.SFC<CustomArrowProps> = ({ onClick, className }) => {
  return (
    <div className={classNames(styles.nextArrow, className)} onClick={onClick}>
      <ArrowRight className={styles.arrowIcon} />
    </div>
  )
}

const PrevArrow: React.SFC<CustomArrowProps> = ({ onClick, className }) => {
  return (
    <div className={classNames(styles.prevArrow, className)} onClick={onClick}>
      <ArrowLeft className={styles.arrowIcon} />
    </div>
  )
}

const Slider: React.SFC<Props> = ({ children, settings }) => {
  /**
   * We don't render carousels on node due to the SSR problems slick carousel has.
   */
  if (process.env.TARGET === 'node') {
    return null
  }

  const breakpoints = [
    {
      breakpoint: 1400,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3
      }
    },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]

  return (
    <SliderWithScrollLock
      initialSlide={0}
      slidesToScroll={4}
      slidesToShow={4}
      responsive={breakpoints}
      className={styles.slider}
      nextArrow={<NextArrow />}
      prevArrow={<PrevArrow />}
      infinite={false}
      dots={false}
      {...settings}
    >
      {children}
    </SliderWithScrollLock>
  )
}

export default Slider
